import { getCarePeriodPage, type CarePeriod } from '../endpoints';
import readCompleteList from '../../readCompleteList';

export default async function getProgramPeriods(programid: string): Promise<CarePeriod[]> {
  return readCompleteList((limit) => getCarePeriodPage(programid, 0, limit), (cp) => {
    if (String(cp.programid) !== programid) throw new Error('Care episode program mismatch.');
    return String(cp.care_period_id ?? '');
  });
}
